// project
import { StudyDataChannel } from "@/psychlab/types/study"
// local
import { WizardContext } from "../types/WizardContext";

export const CountChannelValue = {
	name: "CountChannelValue",
	description: "Counts how often a certain value appears in a data channel.",
	parameters: {
		channel: {
			type:"string",
			drawer(context:WizardContext){
				return {
					type:"dropdown",
					options:getChannelDropdownOptions(context.channels.filter(isCountable))
				}
			},
			default:null
		},
		value:{
			type:"any",
			dependencies:[ "channel" ],
			drawer(context:WizardContext){

				const channelKey = context.dataArgs["channel"];
				if(!channelKey){ return null; }
				const channel = context.channels.find(c => c.key === channelKey);
				if(!channel){ return null; }
				return getChannelDrawer(channel);
			}
		}
	},
	output:{
		n:{
			type:"number"
		}
	}
};


const isCountable = (channel:any) => {
	return [ "form/answer" ].findIndex(v => v === channel.type) < 0;
};

const getChannelDropdownOptions = (channels:any[]) => {
	return channels.map(c => {
		return {
			text:c.name,
			value:c.key,
			group: c.group,
			groupName: c.groupName,
		};
	});
};


const getChannelDrawer = (channel:StudyDataChannel) => {

	switch(channel.type){
		case "form/dropdown":
		case "form/multiplechoice":
		case "form/linearscale/row":
		case "gallery/feedback/scale":
			return {
				type:"dropdown",
				options:(channel.options || []).map((o, i) => {
					return {
						text: o ? `${i} | ${o}` : i,
						value: i,
					};
				})
			}
		case "form/checkboxes/option":
			return {
				type:"dropdown",
				options:[
					{ value: 0, text: "False" },
					{ value: 1, text: "True" },
				]
			}
	}

	return {
		type:"text"
	};
	

};